$(document).ready(function () {
  $(document).on('submit', '#event_search_form', function () {
    $.ajax({
      type: 'POST',
      url: '/ajax/organizer_events/search',
      data: {
        serialized_post: $(this).serialize(),
      },
    })
      .done(function (data) {
        if (data.html !== undefined && data.html !== null) {
          $('#event-list').remove();
          $('#event-list-search').after(data.html);
        }
      })
      .fail(function (data) {
        if (
          data.responseJSON.redirect_url !== undefined &&
          data.responseJSON.redirect_url !== null
        ) {
          document.location.href = data.responseJSON.redirect_url;
        }
      });

    return false;
  });
});
